import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "react-select";

import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Switch from "@material-ui/core/Switch";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { instance } from "Actions/AxiosInstance";
import { CheckActionPermission, RightDrawer } from "Actions/commonAction";
import { GetMasterData } from "Actions/MasterCodeAction";
import defaultEmp from "Assets/Images/defaultEmp.svg";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import calendarIcon from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import employeeIcon from "Assets/newicons/user/employees/outline/employees-outline-16px.svg";
import checkall from "Assets/Svg/check-all.svg";
import emp360 from "Assets/Svg/emp360.svg";
// import {
//   List,
//   TDTypeConsts,
// } from "Module/Subscription/business-configration/commons";
import eyeball from "Assets/Svg/eyeballs.svg";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import raisinghands from "Assets/Svg/raising-hands.svg";
import sleepface from "Assets/Svg/sleep-face.svg";
import classNames from "classnames";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import IconLabel from "Component/Labels/IconLabel";
import LoaderComponent from "Component/Loader/index";
import SearchSq from "Component/Material-ui/SearchSq";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { ErrorMessages } from "Constants";
import headersList from "Constants/headersList";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getFormattedImageLink, shortmonths } from "Utils";
import { GetFeature } from "../../../../../Actions/commonAction";
import {
  startLoadProcess,
  stopLoadProcess,
} from "../../../../../Actions/SaveProgressAction";
import DynamicForm from "../../../../../Component/DynamicForm";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import EmpList from "../EmpList";
import SelfReviews from "../Employee/SelfReviews";
import Cards from "./Cards";
import OpenForm from "./OpenForm";
import Results from "./Results";

const styles = () => ({
  root: {
    overflowy: "hidden",
  },
  drawerPaper: {
    width: "30%",
  },
  table: {
    width: "100%",
  },
  TableCell: {
    padding: "14px 16px 14px 16px",
    borderBottom: "none",
  },
  TableRow: {
    borderRadius: 4,
  },
});

let CALLAPI = true;

class SpecialAccess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      threecodes: [],
      fourcodes: [],
      selectedstatustype: null,
      fivecodes: [],
      typeone: [],
      typetwo: [],
      typethree: [],
      typefour: [],
      typefive: [],
      forms: [],
      tempforms: [],
      searchFormValue: null,
      cycleid: null,
      statusList: [],
      performcycles: [],
      searchexcludeparticipantValue: null,
      searchparticipantValue: null,
      selectedparticipants: [],
      removeparticipantdata1: [],
      addparticipantdata1: [],
      excludeparticipantratingdata1: [],
      extendclosingparticipantdata1: [],
      statusid: 0,
      selectedcycle: null,
      selectedempid: null,
      empform: null,
      empList: [],
      removeparticipantdata: [],
      addparticipantdata: [],
      excludeparticipantratingdata: [],
      includeparticipantratingdata: [],
      includeparticipantratingdata1: [],
      bempList: [],
      permissions: { editable: true, readonly: true },
      searchValue: "",
      value: 0,
      tabId: 0,
      resubmissiondata: [],
      resubmissiondata1: [],
      sortmenu: false,
      sort_anchorEl: null,
      selectedemp: null,
      selectedform: null,
      employeeid: null,
      employeeids: [],
      participanttypeid: null,
      allemps: [],
      ParticipantType: [],
      addHoc: false,
      drawerOpen: false,
      draweractionid: null,
      datareceived: false,
      selectedopenreviewemps: [],
      opendate: null,
      closedate: null,
      isOpenReviewForm: false,
      openForms: [],
      empList1: [],
      manualreviewformid: null,
      actionemp: null,
      limit: 12,
      offset: 0,
      totalcount: 1,
      createmenu: false,
      create_anchorEl: null,
      isoverview: true,
      participantselectedid: null,
      ongoingcount: [],
      onholdcount: [],
      readytoreleasecount: [],
      showcancelreview: false,
      selflist: [],
      durationsData: [
        { displayname: "This week", displayvalue: 1 },
        { displayname: "This fortnight", displayvalue: 2 },
        { displayname: "This month", displayvalue: 3 },
        { displayname: "This year", displayvalue: 4 },
      ],
      durationid: 1,
      // fromdate: new Date(new Date().setDate(new Date().getDate() - 7)),
      // todate: new Date(),
      SelectedEmpData: null,
    };

    this.getForms = this.getForms.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleVerticalChange = this.handleVerticalChange.bind(this);
    this.setStatus = this.setStatus.bind(this);
    this.takeAction = this.takeAction.bind(this);
    this.HelperSliderFlag = this.HelperSliderFlag.bind(this);
    this.editForm = this.editForm.bind(this);
    this.getForm = this.getForm.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleActionSearch = this.handleActionSearch.bind(this);
    this.handleSearchExclude = this.handleSearchExclude.bind(this);
    this.setAddHoc = this.setAddHoc.bind(this);
    this.handleChangeAddHoc = this.handleChangeAddHoc.bind(this);
    this.selectStatusList = this.selectStatusList.bind(this);
    this.saveAdHoc = this.saveAdHoc.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.clearOpenForm = this.clearOpenForm.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.takeAction1 = this.takeAction1.bind(this);
    this.handleFormSearch = this.handleFormSearch.bind(this);
    this.getoverview = this.getoverview.bind(this);
    this.getstatuscount = this.getstatuscount.bind(this);
    this.changeToggle = this.changeToggle.bind(this);
    this.setreleasedduration = this.setreleasedduration.bind(this);
    // this.UpdateSelectedEmpId = this.UpdateSelectedEmpId.bind(this);
  }

  async componentDidMount() {
    const [isManangeform, permissions] = CheckActionPermission("managefrom");
    const [isEmpform, emppermissions] = CheckActionPermission("employeereview");
    if (this.props.history.location.pathname.includes("form")) {
      if (isManangeform) {
        this.setState({ permissions });
        const { masterprofileid } = this.props.AuthenticationAction.login;
        const status = await GetMasterData("ReviewFormStatus");
        const performcycle = await instance.get("perform/getsubperformcycle");
        this.getstatuscount();
        const data1 = await instance.get(`perform/getratingscale`);
        const threepoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 1,
        );
        const threecodes = [];
        const fourcodes = [];
        const fivecodes = [];
        const typeone = [];
        const typetwo = [];
        const typethree = [];
        const typefour = [];
        const typefive = [];
        threepoint &&
          Object.keys(threepoint).forEach((key) => {
            if (
              key == "oneunicode" ||
              key == "twounicode" ||
              key == "threeunicode"
            ) {
              threecodes.push(threepoint[key]);
            }
            if (key == "scaleone" || key == "scaletwo" || key == "scalethree") {
              typeone.push(threepoint[key]);
            }
          });
        const fourpoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 2,
        );
        fourpoint &&
          Object.keys(fourpoint).forEach((key) => {
            if (
              key == "oneunicode" ||
              key == "twounicode" ||
              key == "threeunicode" ||
              key == "fourunicode"
            ) {
              fourcodes.push(fourpoint[key]);
            }
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour"
            ) {
              typetwo.push(fourpoint[key]);
            }
          });
        const fivepoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 3,
        );
        fivepoint &&
          Object.keys(fivepoint).forEach((key) => {
            if (
              key == "oneunicode" ||
              key == "twounicode" ||
              key == "threeunicode" ||
              key == "fourunicode" ||
              key == "fiveunicode"
            ) {
              fivecodes.push(fivepoint[key]);
            }
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour" ||
              key == "scalefive"
            ) {
              typethree.push(fivepoint[key]);
            }
          });
        const sevenpoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 4,
        );
        sevenpoint &&
          Object.keys(sevenpoint).forEach((key) => {
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour" ||
              key == "scalefive" ||
              key == "scalesix" ||
              key == "scaleseven"
            ) {
              typefour.push(sevenpoint[key]);
            }
          });
        const tenpoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 5,
        );
        tenpoint &&
          Object.keys(tenpoint).forEach((key) => {
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour" ||
              key == "scalefive" ||
              key == "scalesix" ||
              key == "scaleseven" ||
              key == "scaleeight" ||
              key == "scalenine"
            ) {
              typefive.push(tenpoint[key]);
            }
          });

        this.getRatingScale();
        this.setState(
          {
            threecodes,
            fourcodes,
            fivecodes,
            typeone,
            typetwo,
            typethree,
            typefour,
            typefive,
            statusList: status.data.result,
            performcycles:
              performcycle.data.result &&
              performcycle.data.result.map((x) => ({
                ...x,
                displayvalue: x.performcycledurationid,
              })),
            statusid: 0,
            // durationid: null,
            value: this.props.history.location.pathname.includes("employee")
              ? 1
              : 0,
            cycleid:
              performcycle.data.result &&
              performcycle.data.result.find((x) => x.performcycletypeid == 2) &&
              performcycle.data.result.find((x) => x.performcycletypeid == 2)
                .performcycledurationid,
            datareceived: this.props.history.location.pathname.includes(
              "employee",
            )
              ? true
              : false,
          },
          () => {
            this.state.value == 0
              ? this.getForms()
              : this.props.stopLoadProcess();
            this.getAllEmp();
            this.getForms();
            if (masterprofileid != 9) {
              this.GetEmployeeDetails();
            }
          },
        );
      } else {
        this.setState({ permissiondenied: true });
      }
    } else if (this.props.history.location.pathname.includes("employee")) {
      if (isEmpform) {
        this.setState({ emppermissions });
        const { masterprofileid } = this.props.AuthenticationAction.login;
        const status = await GetMasterData("ReviewFormStatus");
        const performcycle = await instance.get("perform/getsubperformcycle");
        this.getstatuscount();
        const data1 = await instance.get(`perform/getratingscale`);
        const threepoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 1,
        );
        this.setreleasedduration();
        const threecodes = [];
        const fourcodes = [];
        const fivecodes = [];
        const typeone = [];
        const typetwo = [];
        const typethree = [];
        const typefour = [];
        const typefive = [];
        threepoint &&
          Object.keys(threepoint).forEach((key) => {
            if (
              key == "oneunicode" ||
              key == "twounicode" ||
              key == "threeunicode"
            ) {
              threecodes.push(threepoint[key]);
            }
            if (key == "scaleone" || key == "scaletwo" || key == "scalethree") {
              typeone.push(threepoint[key]);
            }
          });
        const fourpoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 2,
        );
        fourpoint &&
          Object.keys(fourpoint).forEach((key) => {
            if (
              key == "oneunicode" ||
              key == "twounicode" ||
              key == "threeunicode" ||
              key == "fourunicode"
            ) {
              fourcodes.push(fourpoint[key]);
            }
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour"
            ) {
              typetwo.push(fourpoint[key]);
            }
          });
        const fivepoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 3,
        );
        fivepoint &&
          Object.keys(fivepoint).forEach((key) => {
            if (
              key == "oneunicode" ||
              key == "twounicode" ||
              key == "threeunicode" ||
              key == "fourunicode" ||
              key == "fiveunicode"
            ) {
              fivecodes.push(fivepoint[key]);
            }
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour" ||
              key == "scalefive"
            ) {
              typethree.push(fivepoint[key]);
            }
          });
        const sevenpoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 4,
        );
        sevenpoint &&
          Object.keys(sevenpoint).forEach((key) => {
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour" ||
              key == "scalefive" ||
              key == "scalesix" ||
              key == "scaleseven"
            ) {
              typefour.push(sevenpoint[key]);
            }
          });
        const tenpoint = data1.data.result.find(
          (rate) => rate.ratingscaletypeid == 5,
        );
        tenpoint &&
          Object.keys(tenpoint).forEach((key) => {
            if (
              key == "scaleone" ||
              key == "scaletwo" ||
              key == "scalethree" ||
              key == "scalefour" ||
              key == "scalefive" ||
              key == "scalesix" ||
              key == "scaleseven" ||
              key == "scaleeight" ||
              key == "scalenine"
            ) {
              typefive.push(tenpoint[key]);
            }
          });
        this.setState(
          {
            threecodes,
            fourcodes,
            fivecodes,
            typeone,
            typetwo,
            typethree,
            typefour,
            typefive,
            statusList: status.data.result,
            performcycles:
              performcycle.data.result &&
              performcycle.data.result.map((x) => ({
                ...x,
                displayvalue: x.performcycledurationid,
              })),
            statusid: 2,
            durationid: 1,
            value: this.props.history.location.pathname.includes("employee")
              ? 1
              : 0,
            cycleid:
              performcycle.data.result &&
              performcycle.data.result.find((x) => x.performcycletypeid == 2) &&
              performcycle.data.result.find((x) => x.performcycletypeid == 2)
                .performcycledurationid,
            datareceived: this.props.history.location.pathname.includes(
              "employee",
            )
              ? true
              : false,
          },
          () => {
            this.state.value == 0
              ? this.getForms()
              : this.props.stopLoadProcess();
            this.getAllEmp();
            if (masterprofileid != 9) {
              this.GetEmployeeDetails();
            }
          },
        );
      } else {
        this.setState({ permissiondenied: true });
      }
    }
  }

  setreleasedduration() {
    this.setState({ durationid: 1 });
  }

  GetEmployeeDetails() {
    const data = {
      featurekey: "degree",
      workflowfortypeid: 6,
    };
    instance
      .post(`attendance/approverreportee`, data)
      .then((result) => {
        const arrAllEmp = result.data.result;
        const opt = [];
        opt.push({
          label: "Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 1,
          ),
        });

        opt.push({
          label: "In-Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 3,
          ),
        });

        this.setState({ empList1: opt, datareceived: true });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getAllEmp() {
    const { login } = this.props.AuthenticationAction;
    const data = {
      featurekey: "degree",
      subscriptionid: login.subscriptionid,
      statusid: 0,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        const arrAllEmp = result.data.result;
        const opt = [];
        opt.push({
          label: "Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 1,
          ),
        });

        opt.push({
          label: "In-Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 3,
          ),
        });

        this.setState({
          allemps: opt,
          allemps1: arrAllEmp,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleTabChange(event, value) {
    this.setState(
      {
        value,
        forms: [],
        statusid: 1,
        employeeid: null,
        selectedemp: null,
        empform: null,
        selectedempid: null,
        actionemp: null,
        totalcount: 1,
        offset: 0,
        datareceived: true,
        // durationid: this.props.history.location.pathname.includes("employee")
        //   ? 1
        //   : null,
      },
      () => {
        // value == 0 && this.getForms();
        value == 1 && this.setreleasedduration();
        this.props.startLoadProcess();
        this.props.history.push(
          `/${
            value == 0 ? "app/perform/360/form" : "app/perform/360/employee"
          }`,
        );
      },
    );
  }

  handleVerticalChange(id) {
    this.setState(
      {
        tabId: id,
        statusid: id == 1 ? 2 : this.state.statusid,
        totalcount: 1,
        offset: 0,
        forms: [],
      },
      () => {
        (id == 0 || id == 1) && this.state.employeeid && this.getForms();
        // id == 1 && this.getResultForms();
        // preffereces
        // id == 2 &&
        //   this.state.employeeid &&
        //   this.child &&
        //   this.child.gePreferences();
      },
    );
  }

  getForms() {
    this.setState(
      {
        sortmenu: false,
        sort_anchorEl: null,
      },
      () => {
        const {
          statusid,
          value,
          employeeid,
          limit,
          totalcount,
          offset,
          forms,
          durationid,
        } = this.state;
        const data = {
          accesstypeid: 2,
          tabtypeid: value == 0 ? 1 : 2,
          performcycledurationid: this.state.cycleid,
          statusid: value == 1 ? 2 : statusid,
          offset,
          limit,
          employeeid: employeeid ? employeeid : null,
          isparticipant: true,
          isbarrequired: true,
          fromdate:
            this.state.value == 1 && durationid == 1
              ? moment(
                  new Date(new Date().setDate(new Date().getDate() - 7)),
                ).format("YYYY-MM-DD")
              : this.state.value == 1 && durationid == 2
              ? moment(
                  new Date(new Date().setDate(new Date().getDate() - 14)),
                ).format("YYYY-MM-DD")
              : this.state.value == 1 && durationid == 3
              ? moment(
                  new Date(new Date().setDate(new Date().getDate() - 30)),
                ).format("YYYY-MM-DD")
              : this.state.value == 1 && durationid == 4
              ? this.state.selectedcycle1
                ? this.state.selectedcycle1.cyclestartdate
                : this.state.selectedcycle.cyclestartdate
              : null, // this.state.value == 0 ? null : null,
          todate:
            this.state.value == 1 && durationid == 1
              ? moment(new Date()).format("YYYY-MM-DD")
              : this.state.value == 1 && durationid == 2
              ? moment(new Date()).format("YYYY-MM-DD")
              : this.state.value == 1 && durationid == 3
              ? moment(new Date()).format("YYYY-MM-DD")
              : this.state.value == 1 && durationid == 4
              ? this.state.selectedcycle1
                ? this.state.selectedcycle1.cycleenddate
                : this.state.selectedcycle.cycleenddate
              : null, // this.state.value == 0 && durationid == null ? null : null,
        };
        if (CALLAPI) {
          if (totalcount && offset < totalcount && forms.length < totalcount) {
            CALLAPI = false;
            this.props.startLoadProcess();
            instance
              .post("perform/getemployeereview", data)
              .then((result) => {
                let ListData = [];
                CALLAPI = true;
                result.data.result.length > 0
                  ? (ListData = [...forms, ...result.data.result])
                  : (ListData = forms);
                this.setState(
                  {
                    forms: ListData,
                    datareceived: true,
                    offset: offset + this.state.limit,
                    totalcount: ListData[0] ? ListData[0].fullcount : 1,
                    // tempforms: result.data.result,
                    tempforms: ListData,
                    // durationid:
                    //   this.state.value == 0 ? null : this.state.durationid,
                  },
                  () => {
                    this.props.stopLoadProcess();
                  },
                );
              })
              .catch((error) => {
                this.props.stopLoadProcess();
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          }
        }
      },
    );
  }

  setStatus(statusid) {
    this.setState(
      {
        statusid,
        sortmenu: false,
        sort_anchorEl: null,
        totalcount: 1,
        offset: 0,
        forms: [],
        datareceived: false,
        showcancelreview: statusid == 3 ? true : false,
      },
      () => {
        this.getForms();
      },
    );
  }

  takeAction1(e, data1, actionid1) {
    console.log("actionid: ", actionid1);
    console.log("data: ", data1);
    const empdata1 = data1.map((x) => ({
      empreviewformid: x.empreviewformid,
      empreviewdetailid: x.empreviewdetailid,
    }));

    const empdata2 = data1.map((x) => ({
      empreviewdetailid: x,
    }));

    const empdata3 = data1
      .filter((x) => x.extendeddays > 0)
      .map((x) => ({
        empreviewformid: x.empreviewformid,
        empreviewdetailid: x.empreviewdetailid,
        extendeddays: x.extendeddays,
      }));

    const data = {
      actionid: actionid1,
      empdata:
        actionid1 == 10 ? empdata2 : actionid1 == 9 ? empdata3 : empdata1,
    };

    console.log("data: ", data);
    const msg =
      data.actionid == 6
        ? "Are you sure you want to release this form?"
        : data.actionid == 5
        ? "Are you sure you want to hold this form?"
        : data.actionid == 4
        ? "Are you sure you want to cancel this form?"
        : data.actionid == 1
        ? "Are you sure you want to skip this participant?"
        : data.actionid == 2
        ? "Are you sure you want to skip ratings of this participant?"
        : data.actionid == 7
        ? "Are you sure you want to add this participant?"
        : data.actionid == 8
        ? "Are you sure you want to include ratings of this participant?"
        : data.actionid == 10
        ? "Are you sure you want to resubmit this participant?"
        : data.actionid == 9
        ? "Are you sure you want to extend closing date for these participant?"
        : "";
    const successmsg =
      data.actionid == 6
        ? "Released successfully"
        : data.actionid == 7
        ? "added successfully"
        : data.actionid == 5
        ? "Form held successfully"
        : data.actionid == 4
        ? "Cancelled successfully"
        : data.actionid == 1
        ? "Saved successfully"
        : data.actionid == 2
        ? "Saved successfully"
        : data.actionid == 9
        ? "Closing date extended successfully"
        : "Saved successfully";
    this.props.enqueueSnackbar(msg, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            instance
              .post("perform/actionreviewform", data)
              .then(() => {
                this.props.enqueueSnackbar(successmsg, {
                  variant: "success",
                });
                if (
                  data.actionid == 1 ||
                  data.actionid == 2 ||
                  data.actionid == 7 ||
                  data.actionid == 8 ||
                  data.actionid == 10 ||
                  data.actionid == 9
                ) {
                  this.setState(
                    {
                      draweractionid: null,
                      removeparticipantdata: [],
                      addparticipantdata: [],
                      excludeparticipantratingdata: [],
                      removeparticipantdata1: [],
                      addparticipantdata1: [],
                      selectedparticipants: [],
                      excludeparticipantratingdata1: [],
                      includeparticipantratingdata: [],
                      includeparticipantratingdata1: [],
                      selflist: [],
                      drawerOpen: false,
                      addHoc: false,
                      ParticipantType: [],
                      isOpenReviewForm: false,
                    },
                    () => this.editForm(this.state.selectedemp, true),
                  );
                } else {
                  this.setState(
                    {
                      forms: [],
                      offset: 0,
                      totalcount: 1,
                      datareceived: false,
                      draweractionid: null,
                      drawerOpen: false,
                      removeparticipantdata: [],
                      addparticipantdata: [],
                      selectedparticipants: [],
                      excludeparticipantratingdata: [],
                      includeparticipantratingdata: [],
                      includeparticipantratingdata1: [],
                      removeparticipantdata1: [],
                      addparticipantdata1: [],
                      selflist: [],
                      addHoc: false,
                      ParticipantType: [],
                      isOpenReviewForm: false,
                      excludeparticipantratingdata1: [],
                    },
                    () => {
                      this.getForms();
                    },
                  );
                }
              })
              .catch(() => {
                // this.props.enqueueSnackbar(
                //   error.response ? error.response.data.error.message : error.message,
                //   { variant: "error" },
                // );
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  takeAction(form, data) {
    console.log("data: ", data);
    const msg =
      data.actionid == 6
        ? "Are you sure you want to release this form?"
        : data.actionid == 5
        ? "Are you sure you want to hold this form?"
        : data.actionid == 4
        ? "Are you sure you want to cancel this form?"
        : data.actionid == 1
        ? "Are you sure you want to skip this participant?"
        : data.actionid == 2
        ? "Are you sure you want to skip ratings of this participant?"
        : data.actionid == 7
        ? "Are you sure you want to add this participant?"
        : data.actionid == 8
        ? "Are you sure you want to include ratings of this participant?"
        : "";
    const successmsg =
      data.actionid == 6
        ? "Released successfully"
        : data.actionid == 5
        ? "Form held successfully"
        : data.actionid == 4
        ? "Cancelled successfully"
        : // : data.actionid == 1
          // ? "Saved successfully"
          // : data.actionid == 2
          // ? "Saved successfully"
          "Saved successfully";
    this.props.enqueueSnackbar(msg, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            instance
              .post("perform/actionreviewform", data)
              .then(() => {
                this.props.enqueueSnackbar(successmsg, {
                  variant: "success",
                });
                if (
                  data.actionid == 1 ||
                  data.actionid == 2 ||
                  data.actionid == 7 ||
                  data.actionid == 8
                ) {
                  this.editForm(this.state.selectedemp, true);
                } else {
                  this.setState(
                    {
                      forms: [],
                      offset: 0,
                      totalcount: 1,
                      datareceived: false,
                    },
                    () => {
                      this.getForms();
                      this.getstatuscount();
                    },
                  );
                }
              })
              .catch(() => {
                // this.props.enqueueSnackbar(
                //   error.response ? error.response.data.error.message : error.message,
                //   { variant: "error" },
                // );
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  HelperSliderFlag(side, flag, text, config, event) {
    event.stopPropagation();
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    // this.props.RightDrawer({ drawerdata: text, open: flag });
    this.props.RightDrawer({
      drawerdata: text,
      open: side,
      side: flag,
      configid: config,
    });
    // this.props.RightDrawer({ drawerdata: this.state.EmpList, open: flag });
  }

  editForm(data, isrefresh) {
    console.log("isrefresh: ", isrefresh);
    console.log("data: ", data);
    this.setState(
      {
        selectedemp: data,
        empform: null,
        forms: this.state.value == 0 ? this.state.forms : [],
        offset: this.state.value == 0 ? this.state.offset : 0,
        totalcount: this.state.value == 0 ? this.state.totalcount : 1,
      },
      () => {
        data &&
          instance
            .get(`perform/getempreviewformparticipant/${data.empreviewformid}`)
            .then((result1) => {
              const obj =
                data &&
                result1.data.result.find(
                  (x) => x.employeeid == data.employeeid,
                );
              this.setState(
                {
                  empList: result1.data.result,
                  bempList: result1.data.result,
                  removeparticipantdata: result1.data.result.filter(
                    (x) => x.skippartcipant == false,
                  ),
                  tempremoveparticipantdata: result1.data.result.filter(
                    (x) => x.skippartcipant == false,
                  ),
                  addparticipantdata: result1.data.result.filter(
                    (x) => x.skippartcipant == true,
                  ),
                  tempaddparticipantdata: result1.data.result.filter(
                    (x) => x.skippartcipant == true,
                  ),
                  tempexcludeparticipantratingdata: result1.data.result.filter(
                    (x) => x.skiprating == false,
                  ),
                  excludeparticipantratingdata: result1.data.result.filter(
                    (x) => x.skiprating == false,
                  ),
                  includeparticipantratingdata: result1.data.result.filter(
                    (x) => x.skiprating == true,
                  ),
                  tempincludeparticipantratingdata: result1.data.result.filter(
                    (x) => x.skiprating == true,
                  ),
                  resubmissiondata: result1.data.result
                    .filter((x) => x.formstatusid == 3)
                    .map((element) => ({
                      displayvalue: element.empreviewdetailid,
                      displayname: element.fullname,
                    })),
                },
                () => {
                  isrefresh && obj && this.getForm(obj);
                  if (this.state.empList) {
                    const selflist = this.state.empList;

                    selflist &&
                      selflist.forEach((item) => {
                        if (!item.extendeddays) {
                          item.extendeddays = 0;
                        }
                      });

                    this.setState({ selflist });
                  }
                },
              );
            })
            .catch((error) => {
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
      },
    );
  }

  getstatuscount() {
    instance
      .get(
        `perform/reviewstatuscard/${
          this.state.cycleid ? this.state.cycleid : ""
        }`,
      )
      .then((result1) => {
        this.setState({
          ongoingcount:
            result1.data.result.filter((x) => x.statusid == 1) || [],
          readytoreleasecount:
            result1.data.result.filter((x) => x.statusid == 5) || [],
          onholdcount: result1.data.result.filter((x) => x.statusid == 4) || [],
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getForm(emp) {
    this.setState(
      {
        actionemp: emp,
        selectedempid: emp.empreviewdetailid,
        isoverview: false,
      },
      () => {
        instance
          .get(`perform/getfeedbackform/${emp.empreviewdetailid}`)
          .then((result) => {
            this.setState({
              empform: result.data.result[0],
            });
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      },
    );
  }

  getoverview() {
    this.setState({
      isoverview: true,
    });
  }

  getRatingScale() {
    instance
      .get(`perform/getratingscale`)
      .then((result) => {
        if (result.data.result.length > 0) {
          const ratings = [
            result.data.result.find((x) => x.ratingscaletypeid == 1),
            result.data.result.find((x) => x.ratingscaletypeid == 2),
            result.data.result.find((x) => x.ratingscaletypeid == 3),
            result.data.result.find((x) => x.ratingscaletypeid == 4),
            result.data.result.find((x) => x.ratingscaletypeid == 5),
          ];
          const threescalecodes = [];
          const fourscalecodes = [];
          const fivescalecodes = [];
          const sevenscalecodes = [];
          const tenscalecodes = [];
          const threepoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 1,
          );
          threepoint &&
            Object.keys(threepoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree"
              ) {
                threescalecodes.push(threepoint[key]);
              }
            });
          const fourpoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 2,
          );
          fourpoint &&
            Object.keys(fourpoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour"
              ) {
                fourscalecodes.push(fourpoint[key]);
              }
            });
          const fivepoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 3,
          );
          fivepoint &&
            Object.keys(fivepoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour" ||
                key == "scalefive"
              ) {
                fivescalecodes.push(fivepoint[key]);
              }
            });
          const sevenpoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 4,
          );
          sevenpoint &&
            Object.keys(sevenpoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour" ||
                key == "scalefive" ||
                key == "scalesix" ||
                key == "scaleseven"
              ) {
                sevenscalecodes.push(sevenpoint[key]);
              }
            });
          const tenpoint = result.data.result.find(
            (rate) => rate.ratingscaletypeid == 5,
          );
          tenpoint &&
            Object.keys(tenpoint).forEach((key) => {
              if (
                key == "scaleone" ||
                key == "scaletwo" ||
                key == "scalethree" ||
                key == "scalefour" ||
                key == "scalefive" ||
                key == "scalesix" ||
                key == "scaleseven" ||
                key == "scaleeight" ||
                key == "scalenine" ||
                key == "scaleten"
              ) {
                tenscalecodes.push(tenpoint[key]);
              }
            });
          this.setState({
            allratings: ratings,
            threescalecodes,
            fourscalecodes,
            fivescalecodes,
            sevenscalecodes,
            tenscalecodes,

            isratingscaledata: true,
          });
        } else {
          this.setState({ isratingscaledata: false });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleActionSearch(e, actionid) {
    const {
      removeparticipantdata,
      tempremoveparticipantdata,
      tempaddparticipantdata,
      tempexcludeparticipantratingdata,
      excludeparticipantratingdata,
      includeparticipantratingdata,
      tempincludeparticipantratingdata,
    } = this.state;
    if (actionid == 1) {
      const filterList = tempremoveparticipantdata.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchparticipantValue: e.target.value,
        removeparticipantdata: e.target.value
          ? filterList
          : tempremoveparticipantdata,
      });
    } else if (actionid == 7) {
      const filterList = tempaddparticipantdata.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchparticipantValue: e.target.value,
        addparticipantdata: e.target.value
          ? filterList
          : tempaddparticipantdata,
      });
    } else if (actionid == 2) {
      const filterList = tempexcludeparticipantratingdata.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchexcludeparticipantValue: e.target.value,
        excludeparticipantratingdata: e.target.value
          ? filterList
          : tempexcludeparticipantratingdata,
      });
    } else if (actionid == 8) {
      const filterList = tempincludeparticipantratingdata.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchincludeparticipantValue: e.target.value,
        includeparticipantratingdata: e.target.value
          ? filterList
          : tempincludeparticipantratingdata,
      });
    }
  }

  handleSearch(e) {
    const { bempList, empList } = this.state;
    const filterList = empList.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      empList: e.target.value ? filterList : bempList,
    });
  }

  handleFormSearch(e) {
    const { tempforms } = this.state;
    const filterFormList = tempforms.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchFormValue: e.target.value,
      forms: e.target.value ? filterFormList : tempforms,
    });
  }

  handleSearchExclude(e) {
    const { tempforms } = this.state;
    const filterFormList = tempforms.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchFormValue: e.target.value,
      forms: e.target.value ? filterFormList : tempforms,
    });
  }

  openDrawer({ DrawerOpen }) {
    this.setState({
      DrawerOpen,
    });
  }

  handleChange1(event, data, actionid) {
    const {
      removeparticipantdata1,
      addparticipantdata1,
      excludeparticipantratingdata1,
      includeparticipantratingdata1,
      extendclosingparticipantdata1,
    } = this.state;
    console.log("actionid: ", actionid);
    console.log("data: ", data);
    console.log("event: ", event);
    // const removeparticipantdata1 = [];
    if (actionid == 1) {
      const currentFilterIndex =
        this.state.removeparticipantdata1 &&
        this.state.removeparticipantdata1.findIndex(
          (option) => option.employeeid === data.employeeid,
        );
      console.log("currentFilterIndex: ", currentFilterIndex);

      if (currentFilterIndex === -1) {
        this.state.removeparticipantdata1 && removeparticipantdata1.push(data);
        this.setState({
          removeparticipantdata1,
        });
      } else {
        removeparticipantdata1.splice(currentFilterIndex, 1);
        this.setState({
          removeparticipantdata1,
        });
      }
    } else if (actionid == 7) {
      const currentFilterIndex =
        this.state.addparticipantdata1 &&
        this.state.addparticipantdata1.findIndex(
          (option) => option.employeeid === data.employeeid,
        );
      console.log("currentFilterIndex: ", currentFilterIndex);

      if (currentFilterIndex === -1) {
        this.state.addparticipantdata1 && addparticipantdata1.push(data);
        this.setState({
          addparticipantdata1,
        });
      } else {
        addparticipantdata1.splice(currentFilterIndex, 1);
        this.setState({
          addparticipantdata1,
        });
      }
    } else if (actionid == 2) {
      const currentFilterIndex =
        this.state.excludeparticipantratingdata1 &&
        this.state.excludeparticipantratingdata1.findIndex(
          (option) => option.employeeid === data.employeeid,
        );
      console.log("currentFilterIndex: ", currentFilterIndex);

      if (currentFilterIndex === -1) {
        this.state.excludeparticipantratingdata1 &&
          excludeparticipantratingdata1.push(data);
        this.setState({
          excludeparticipantratingdata1,
        });
      } else {
        excludeparticipantratingdata1.splice(currentFilterIndex, 1);
        this.setState({
          excludeparticipantratingdata1,
        });
      }
    } else if (actionid == 10) {
      this.setState({
        [event]: data,
      });
    } else if (actionid == 8) {
      const currentFilterIndex =
        this.state.includeparticipantratingdata1 &&
        this.state.includeparticipantratingdata1.findIndex(
          (option) => option.employeeid === data.employeeid,
        );
      console.log("currentFilterIndex: ", currentFilterIndex);

      if (currentFilterIndex === -1) {
        this.state.includeparticipantratingdata1 &&
          includeparticipantratingdata1.push(data);
        this.setState({
          includeparticipantratingdata1,
        });
      } else {
        includeparticipantratingdata1.splice(currentFilterIndex, 1);
        this.setState({
          includeparticipantratingdata1,
        });
      }
    } else if (actionid == 9) {
      const selflist = this.state.selflist.map((item) => {
        if (item.employeeid == data) {
          item.extendeddays = event;
        }
        return item;
      });
      console.log("selflist: ", selflist);
      if (selflist) {
        this.setState({ selflist }, () => console.log(this.state.selflist));
      }
    }
  }

  handleChange = (key, value) => {
    key == "participantselectedid"
      ? this.setState({
          [key]: value,
        })
      : this.setState(
          {
            selectedcycle: this.state.performcycles.find(
              (c) => c.performcycledurationid == this.state.cycleid,
            ),
            selectedcycle1: this.state.performcycles.find(
              (c) => c.performcycledurationid == value,
            ),
            [key]: value,
            statusid:
              key == "statusid"
                ? value
                : key == "employeeid"
                ? 2
                : this.state.statusid,

            forms: [],
            offset: 0,
            totalcount: 1,
            datareceived:
              this.state.value == 0 ||
              (this.state.value == 1 && this.state.employeeid)
                ? false
                : true,
          },
          () => {
            this.state.value == 0 && this.getForms();
            this.state.value == 1 &&
              (this.state.tabId == 0 || this.state.tabId == 1) &&
              this.state.employeeid &&
              this.getForms();
            this.state.value == 1 && this.state.durationid && this.getForms();

            this.getstatuscount();
            // this.state.value == 1 &&
            //   this.state.tabId == 2 &&
            //   this.state.employeeid &&
            //   this.child.gePreferences();
          },
        );
  };

  UpdateSelectedEmpId(selectedItem) {
    this.setState(
      {
        employeeid: selectedItem ? selectedItem.displayvalue : null,
        SelectedEmpData: selectedItem,
        offset: 0,
        totalcount: 1,
        forms: [],
      },
      () => this.getForms(),
    );
  }

  changeToggle() {
    this.setState(
      {
        // EmployeeList: [],
        // offset: 0,
        showcancelreview: !this.state.showcancelreview,
      },
      () => {
        this.state.showcancelreview ? this.setStatus(3) : this.setStatus(0);
      },
    );
  }

  setAddHoc() {
    const { selectedemp } = this.state;
    instance
      .get(
        `perform/reviewstructureparticipant/${
          selectedemp && selectedemp.reviewstructureid
        }`,
      )
      .then((result) => {
        if (result.data.result.find((part) => part.displayvalue != 1)) {
          this.setState({
            ParticipantType: result.data.result.filter(
              (part) => part.displayvalue != 1,
            ),
            addHoc: true,
            draweractionid: null,
            drawerOpen: true,
            createmenu: false,
          });
        } else {
          this.props.enqueueSnackbar("Participants are not available", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  selectStatusList(e, type) {
    this.setState({
      selectedeventtype: type,
    });
  }

  handleChangeAddHoc(key, value) {
    this.setState({
      [key]: value,
    });
  }

  saveAdHoc() {
    if (
      this.state.employeeids &&
      this.state.employeeids.length > 0 &&
      this.state.participanttypeid
    ) {
      const { selectedemp } = this.state;
      const data = {
        actionid: 3,
        empreviewformid: selectedemp && selectedemp.empreviewformid,
        empreviewdetailid: null,
        employeeids: this.state.employeeids,
        participanttypeid: this.state.participanttypeid,
      };
      this.props.enqueueSnackbar(
        "Are you sure want to add hoc this employees",
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => {
                this.props.closeSnackbar();
                instance
                  .post("perform/actionreviewform", data)
                  .then(() => {
                    this.props.enqueueSnackbar("Save successfully", {
                      variant: "success",
                    });
                    this.setState(
                      {
                        employeeids: [],
                        participanttypeid: null,
                        ParticipantType: [],
                        drawerOpen: false,
                        addHoc: false,
                      },
                      () => {
                        this.editForm(this.state.selectedemp);
                      },
                    );
                  })
                  .catch(() => {
                    // this.props.enqueueSnackbar(
                    //   error.response ? error.response.data.error.message : error.message,
                    //   { variant: "error" },
                    // );
                  });
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    } else {
      this.props.enqueueSnackbar(ErrorMessages.E0020, {
        variant: "error",
      });
    }
  }

  clearOpenForm() {
    this.setState(
      {
        openForms: [],
        drawerOpen: false,
        isOpenReviewForm: false,
        forms: [],
        offset: 0,
        totalcount: 1,
      },
      () => {
        this.getForms();
      },
    );
  }

  render() {
    const { classes } = this.props;
    const { masterprofileid } = this.props.AuthenticationAction.login;
    const {
      forms,
      tabId,
      value,
      openForms,
      cycleid,
      performcycles,
      statusid,
      searchValue,
      empList,
      selectedemp,
      allemps,
      allemps1,
      datareceived,

      selflist,
    } = this.state;
    const selectedcycle = performcycles.find(
      (c) => c.performcycledurationid == cycleid,
    );
    const isSpecialAccess =
      this.props.history.location.pathname.includes("app");
    const adhocemps = allemps1 && allemps1.filter(
      (e) => empList.findIndex((e1) => e1.employeeid == e.displayvalue) == -1,
    );

    const pendingcompletion =
      empList && empList.filter((x) => x.formstatusid == 1);

    const readytoreleasecount1 =
      this.state.readytoreleasecount &&
      this.state.readytoreleasecount.length > 0
        ? this.state.readytoreleasecount[0].count
        : 0;

    const ongoingcount1 =
      this.state.ongoingcount && this.state.ongoingcount.length > 0
        ? this.state.ongoingcount[0].count
        : 0;

    const onholdcount1 =
      this.state.onholdcount && this.state.onholdcount.length > 0
        ? this.state.onholdcount[0].count
        : 0;

    // const allstatuscount =
    //   readytoreleasecount1 > 0 && readytoreleasecount1 +
    //   ongoingcount1 > 0 && ongoingcount1 +
    //   onholdcount1 > 0 && onholdcount1;

    const allstatuscount =
      parseInt(readytoreleasecount1) +
      parseInt(ongoingcount1) +
      parseInt(onholdcount1);

    const managerlist =
      empList && empList.filter((x) => x.participanttypeid == 2);
    const directreportlist =
      empList && empList.filter((x) => x.participanttypeid == 3);
    const coworkerlist =
      empList && empList.filter((x) => x.participanttypeid == 4);
    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Perform.ManageForms.header}</title>
        </Helmet>
        {!datareceived && (
          <div>
            <LoaderComponent />
          </div>
        )}
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            {datareceived && (
              <div className="position-rel">
                {!selectedemp && (
                  <div
                    style={{
                      position: "sticky",
                      top: 54,
                      zIndex: 1,
                      height: 34,
                      background: "#fff",
                    }}
                  ></div>
                )}
                {!selectedemp && (
                  <div
                    className="common-menubar-header-sticky"
                    style={{ marginTop: -34 }}
                  >
                    <p className="large-text-dark-secondary t-bold margin-bottom-16">
                      Performance reviews
                    </p>
                    <div
                      className="display-flex"
                      style={{ justifyContent: "space-between" }}
                    >
                      <Tabs
                        value={this.state.value}
                        onChange={this.handleTabChange}
                        indicatorColor="#fff"
                        textColor="primary"
                        scrollButtons="auto"
                      >
                        {GetFeature("managefrom") && (
                          <Tab
                            label="Manage reviews"
                            disabled={!GetFeature("employeereview")}
                            className={`tabheading ${
                              !this.props.history.location.pathname.includes(
                                "employee",
                              )
                                ? "active-tab1"
                                : "inactive-tab1"
                            } `}
                            style={{ minHeight: 56 }}
                          />
                        )}
                        {GetFeature("employeereview") && (
                          <Tab
                            label="Released reviews"
                            disabled={!GetFeature("managefrom")}
                            className={`tabheading ${
                              this.props.history.location.pathname.includes(
                                "employee",
                              )
                                ? "active-tab1"
                                : "inactive-tab1"
                            } `}
                            style={{ minHeight: 56 }}
                          />
                        )}
                      </Tabs>
                      <div className="display-flex">
                        {value == 1 && (
                          <span
                            className="inline-block margin-right-16"
                            style={{ width: 164 }}
                          >
                            <DynamicForm
                              fields={selectinputconverter({
                                value: this.state.durationid,
                                options: this.state.durationsData,
                                placeholder: "This week",
                                label: "",
                              })}
                              onChange={(id) =>
                                this.handleChange("durationid", id)
                              }
                            />
                          </span>
                        )}
                        {value == 1 && (
                          <span
                            className="inline-block margin-right-16"
                            style={{ width: 240 }}
                          >
                            {/* <DynamicForm
                              fields={selectinputconverter({
                                value: this.state.employeeid,
                                options:
                                  masterprofileid == 9
                                    ? this.state.allemps
                                    : this.state.empList1,
                                placeholder: "Select employee",
                                label: "",
                              })}
                              onChange={(id) =>
                                this.handleChange("employeeid", id)
                              }
                            /> */}
                            <Select
                              className="selectsearch width100"
                              onChange={this.UpdateSelectedEmpId.bind(this)}
                              options={
                                masterprofileid == 9
                                  ? this.state.allemps
                                  : this.state.empList1
                              }
                              getOptionLabel={(option) => option.displayname}
                              getOptionValue={(option) => option.displayvalue}
                              value={this.state.SelectedEmpData}
                              placeholder="Select Employee"
                            />
                          </span>
                        )}
                        <span className="inline-block" style={{ width: 240 }}>
                          <DynamicForm
                            fields={selectinputconverter({
                              value: this.state.cycleid,
                              options: this.state.performcycles,
                              // placeholder: "Select cycle",
                              // label: "Performance cycle",
                            })}
                            onChange={(id) => this.handleChange("cycleid", id)}
                          />
                        </span>
                        {value == 0 && this.state.permissions.editable && (
                          <Button
                            variant="contained"
                            className="btn btn-primary-md-blue margin-left-16"
                            color="primary"
                            onClick={() => {
                              instance
                                .get(`perform/getreviewformlist/2`)
                                .then((result) => {
                                  if (result.data.result.length > 0) {
                                    this.setState({
                                      openForms: result.data.result.filter(
                                        (part) => part.displayvalue != 1,
                                      ),
                                      isOpenReviewForm: true,
                                      drawerOpen: true,
                                    });
                                  } else {
                                    this.props.enqueueSnackbar(
                                      "Review forms are not available",
                                      { variant: "error" },
                                    );
                                  }
                                })
                                .catch((error) => {
                                  this.props.enqueueSnackbar(
                                    error.response
                                      ? error.response.data.error.message
                                      : error.message,
                                    { variant: "error" },
                                  );
                                });
                            }}
                          >
                            New form
                          </Button>
                        )}
                      </div>
                    </div>
                    <div className="tab-border" style={{ top: -2 }}></div>
                  </div>
                )}

                <div
                  style={{
                    marginTop: !selectedemp ? 24 : 0,
                    padding: "0px 2px",
                  }}
                >
                  {!selectedemp && value == 0 && (
                    <Grid container spacing={3}>
                      <Grid item sm={12} md={3}>
                        <Paper
                          className={
                            this.state.statusid == 0
                              ? "rounded-rectangle-div padding24 position-rel text-align-center selected-status-box cursor-pointer"
                              : "rounded-rectangle-div padding24 position-rel text-align-center cursor-pointer"
                          }
                          onClick={() => this.setStatus(0)}
                        >
                          <img src={checkall} width="40" height="40"></img>
                          <p
                            className="large-text-dark-secondary margin-top-24"
                            style={{ color: "#0D0D0D" }}
                          >
                            All
                          </p>
                          <p className="rounded-span-count">{allstatuscount}</p>
                        </Paper>
                      </Grid>
                      <Grid item sm={12} md={3}>
                        <Paper
                          className={
                            this.state.statusid == 5
                              ? "rounded-rectangle-div padding24 position-rel text-align-center selected-status-box cursor-pointer"
                              : "rounded-rectangle-div padding24 position-rel text-align-center cursor-pointer"
                          }
                          onClick={() => this.setStatus(5)}
                        >
                          <img src={raisinghands} width="40" height="40"></img>
                          <p
                            className="large-text-dark-secondary margin-top-24"
                            style={{ color: "#0D0D0D" }}
                          >
                            Ready to release
                          </p>
                          <p className="rounded-span-count">
                            {this.state.readytoreleasecount &&
                            this.state.readytoreleasecount.length > 0
                              ? this.state.readytoreleasecount[0].count
                              : 0}
                          </p>
                        </Paper>
                      </Grid>
                      <Grid item sm={12} md={3}>
                        <Paper
                          className={
                            this.state.statusid == 1
                              ? "rounded-rectangle-div padding24 position-rel text-align-center selected-status-box cursor-pointer"
                              : "rounded-rectangle-div padding24 position-rel text-align-center cursor-pointer"
                          }
                          onClick={() => this.setStatus(1)}
                        >
                          <img src={eyeball} width="40" height="40"></img>
                          <p
                            className="large-text-dark-secondary margin-top-24"
                            style={{ color: "#0D0D0D" }}
                          >
                            Ongoing
                          </p>
                          <p className="rounded-span-count">
                            {this.state.ongoingcount &&
                            this.state.ongoingcount.length > 0
                              ? this.state.ongoingcount[0].count
                              : 0}
                          </p>
                        </Paper>
                      </Grid>
                      <Grid item sm={12} md={3}>
                        <Paper
                          className={
                            this.state.statusid == 4
                              ? "rounded-rectangle-div padding24 position-rel text-align-center selected-status-box cursor-pointer"
                              : "rounded-rectangle-div padding24 position-rel text-align-center cursor-pointer"
                          }
                          onClick={() => this.setStatus(4)}
                        >
                          <img src={sleepface} width="40" height="40"></img>
                          <p
                            className="large-text-dark-secondary margin-top-24"
                            style={{ color: "#0D0D0D" }}
                          >
                            On hold
                          </p>
                          <p className="rounded-span-count">
                            {this.state.onholdcount &&
                            this.state.onholdcount.length > 0
                              ? this.state.onholdcount[0].count
                              : 0}
                          </p>
                        </Paper>
                      </Grid>
                    </Grid>
                  )}

                  {value === 0 && (
                    <div>
                      {!selectedemp ? (
                        <div
                          style={{
                            overflowY: "hidden",
                            maxHeight: "80vh",
                            overflowX: "hidden",
                            flexGrow: 1,
                            height: "80vh",
                          }}
                        >
                          <Grid container>
                            <Grid
                              item
                              md={12}
                              sm={2}
                              justify="flex-end"
                              className="display-flex"
                            >
                              <div className="width100">
                                <div className="floatleft margin-top-16 margin-bottom-16">
                                  <Switch
                                    checked={this.state.showcancelreview}
                                    onChange={this.changeToggle}
                                    value={this.state.showcancelreview}
                                    // name={column}
                                    color="primary"
                                  />
                                  <span className="normal-dark-secondary margin-left-8">
                                    Show cancelled reviews
                                  </span>
                                </div>
                                <div
                                  className="floatright margin-top-16 margin-bottom-16"
                                  style={{ width: 240 }}
                                >
                                  <SearchSq
                                    placeholder="Search employee by name"
                                    value={this.state.searchFormValue}
                                    onChange={(e) => this.handleFormSearch(e)}
                                  />
                                </div>
                                {/* <span
                              className="inline-block margin-right-8"
                              style={{ width: 240 }}
                            >
                              <DynamicForm
                                fields={selectinputconverter({
                                  value: this.state.cycleid,
                                  options: this.state.performcycles,
                                  // placeholder: "Select cycle",
                                  // label: "Performance cycle",
                                })}
                                onChange={(id) =>
                                  this.handleChange("cycleid", id)
                                }
                              />
                            </span>
                            <span className="floatright">
                              <Button
                                variant="contained"
                                className="btn btn-primary-md-blue"
                                color="primary"
                                onClick={() => {
                                  instance
                                    .get(`perform/getreviewformlist/2`)
                                    .then((result) => {
                                      if (result.data.result.length > 0) {
                                        this.setState({
                                          openForms: result.data.result.filter(
                                            (part) => part.displayvalue != 1,
                                          ),
                                          isOpenReviewForm: true,
                                          drawerOpen: true,
                                        });
                                      } else {
                                        this.props.enqueueSnackbar(
                                          "Review forms are not available",
                                          { variant: "error" },
                                        );
                                      }
                                    })
                                    .catch((error) => {
                                      this.props.enqueueSnackbar(
                                        error.response
                                          ? error.response.data.error.message
                                          : error.message,
                                        { variant: "error" },
                                      );
                                    });
                                }}
                              >
                                Open new review form
                              </Button>
                            </span>
                           */}
                              </div>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            {forms && forms.length > 0 ? (
                              <Cards
                                totalcount={this.state.totalcount}
                                forms={forms}
                                statusid={statusid}
                                selectedcycle={selectedcycle}
                                takeAction={this.takeAction}
                                getForms={this.getForms}
                                HelperSliderFlag={this.HelperSliderFlag}
                                openForm={this.editForm}
                                loading={this.props.LoadingReducer.loading}
                              />
                            ) : (
                              <Grid item md={12} sm={12}>
                                <div
                                  style={{ height: "77vh" }}
                                  className="position-rel margin-top-16"
                                >
                                  <DefaultComp
                                    //  text={this.getText()}
                                    heading={"There are no reviews!"}
                                    subheading={
                                      "Reviews will appear once you have been assigned a review form."
                                    }
                                    imageSrc={emp360}
                                  />
                                </div>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                      ) : (
                        <div>
                          <Grid container>
                            <Grid item md={12} sm={12}>
                              <Paper
                                className="rounded-rectangle-paper display-flex"
                                style={{
                                  padding: 16,
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  className="display-flex"
                                  style={{ alignItems: "flex-start" }}
                                >
                                  <div
                                    className="display-flex"
                                    style={{ alignItems: "flex-start" }}
                                  >
                                    <img
                                      src={backArrow}
                                      className="margin-right-16 cursor-pointer"
                                      onClick={() =>
                                        this.setState(
                                          {
                                            selectedemp: null,
                                            empform: null,
                                            employeeid: null,
                                            selectedempid: null,
                                            actionemp: null,
                                            offset: 0,
                                            totalcount: 1,
                                            forms: [],
                                            datareceived: false,
                                          },
                                          () => {
                                            this.getForms();
                                          },
                                        )
                                      }
                                    ></img>
                                    <div className="display-flex">
                                      <div className="margin-right-16">
                                        <ProfilePicture
                                          src={getFormattedImageLink(
                                            selectedemp.imagepath,
                                          )}
                                          height="40"
                                        />
                                      </div>
                                      <div>
                                        <span className="large-dark-secondary display-block">
                                          {selectedemp.fullname}
                                        </span>
                                        <span className="small-dark-secondary">
                                          {selectedemp.designationname}
                                        </span>
                                        <p className="small-dark-secondary margin-top-8">
                                          {selectedemp.formtitle}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ textAlign: "right" }}>
                                  <div>
                                    {selectedemp &&
                                      selectedemp.statusid != 2 &&
                                      /* empList.length > 1 && */ // this was commented because in case of single participant other than employee itslef empList result in length one and take action button wouldn't shown up
                                      // empList.length >= 1 &&
                                      this.state.permissions.editable && (
                                        <Button
                                          variant="contained"
                                          className="btn btn-primary-sm-blue margin-bottom-16"
                                          color="primary"
                                          onClick={(e) =>
                                            this.setState({
                                              createmenu: true,
                                              create_anchorEl: e.currentTarget,
                                            })
                                          }
                                        >
                                          Take action
                                        </Button>
                                      )}
                                    <Popover
                                      open={this.state.createmenu}
                                      anchorEl={this.state.create_anchorEl}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      onClose={() =>
                                        this.setState({
                                          createmenu: false,
                                          create_anchorEl: null,
                                        })
                                      }
                                      className="margin-top-8"
                                    >
                                      <Paper>
                                        <div>
                                          <List
                                            style={{
                                              padding: "4px 0px 4px 0px",
                                            }}
                                          >
                                            <ListItem
                                              button
                                              style={{
                                                padding: "0px 12px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => this.setAddHoc()}

                                              // onClick={() =>
                                              //   this.setState({
                                              //     DrawerOpen: true,
                                              //     draweractionid: 7,
                                              //   })
                                              // }
                                            >
                                              <ListItemText
                                                style={{ padding: 0 }}
                                              >
                                                <span className="small-dark-secondary">
                                                  Add participant (Ad-hoc)
                                                </span>
                                              </ListItemText>
                                            </ListItem>
                                            {empList.length >= 1 && (
                                              <div>
                                                <ListItem
                                                  button
                                                  style={{
                                                    padding: "0px 12px",
                                                    cursor: "pointer",
                                                  }}
                                                  // onClick={() => this.setAddHoc()}

                                                  onClick={() =>
                                                    this.setState({
                                                      drawerOpen: true,
                                                      draweractionid: 7,
                                                      createmenu: false,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    style={{ padding: 0 }}
                                                  >
                                                    <span className="small-dark-secondary">
                                                      Add skipped participant(s)
                                                    </span>
                                                  </ListItemText>
                                                </ListItem>
                                                <ListItem
                                                  button
                                                  style={{
                                                    padding: "0px 12px",
                                                    cursor: "pointer",
                                                  }}
                                                  // onClick={() =>
                                                  //   this.takeAction(empform, 1)
                                                  // }

                                                  onClick={() =>
                                                    this.setState({
                                                      drawerOpen: true,
                                                      draweractionid: 1,
                                                      createmenu: false,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    style={{ padding: 0 }}
                                                  >
                                                    <span className="small-dark-secondary">
                                                      Remove (skip) participant
                                                    </span>
                                                  </ListItemText>
                                                </ListItem>
                                                <ListItem
                                                  button
                                                  className="padding-top-0 padding-bottom-0 padding-left-12 padding-right-12 cursor-pointer"
                                                  // onClick={() =>
                                                  //   this.takeAction(empform, 2)
                                                  // }
                                                  onClick={() =>
                                                    this.setState({
                                                      drawerOpen: true,
                                                      draweractionid: 8,
                                                      createmenu: false,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    style={{ padding: 0 }}
                                                  >
                                                    <span className="small-dark-secondary">
                                                      Include participant’s
                                                      ratings
                                                    </span>
                                                  </ListItemText>
                                                </ListItem>

                                                <ListItem
                                                  button
                                                  className="padding-top-0 padding-bottom-0 padding-left-12 padding-right-12 cursor-pointer"
                                                  // onClick={() =>
                                                  //   this.takeAction(empform, 2)
                                                  // }
                                                  onClick={() =>
                                                    this.setState({
                                                      drawerOpen: true,
                                                      draweractionid: 2,
                                                      createmenu: false,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    style={{ padding: 0 }}
                                                  >
                                                    <span className="small-dark-secondary">
                                                      Exclude participant’s
                                                      ratings
                                                    </span>
                                                  </ListItemText>
                                                </ListItem>

                                                <ListItem
                                                  button
                                                  style={{
                                                    padding: "0px 12px",
                                                    cursor: "pointer",
                                                  }}
                                                  // onClick={() =>
                                                  //   this.takeAction(empform, 8)
                                                  // }
                                                  onClick={() =>
                                                    this.setState({
                                                      drawerOpen: true,
                                                      draweractionid: 9,
                                                      createmenu: false,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    style={{ padding: 0 }}
                                                  >
                                                    <span className="small-dark-secondary">
                                                      Extend closing date
                                                    </span>
                                                  </ListItemText>
                                                </ListItem>
                                                <ListItem
                                                  button
                                                  style={{
                                                    padding: "0px 12px",
                                                    cursor: "pointer",
                                                  }}
                                                  // onClick={() =>
                                                  //   this.takeAction(empform, 8)
                                                  // }
                                                  onClick={() =>
                                                    this.setState({
                                                      drawerOpen: true,
                                                      draweractionid: 10,
                                                      createmenu: false,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    style={{ padding: 0 }}
                                                  >
                                                    <span className="small-dark-secondary">
                                                      Form resubmission
                                                    </span>
                                                  </ListItemText>
                                                </ListItem>
                                              </div>
                                            )}
                                          </List>
                                        </div>
                                      </Paper>
                                    </Popover>
                                  </div>

                                  <div className="display-flex">
                                    {this.state.selectedemp
                                      .reviewperiodtypeid ? (
                                      <div className="display-flex margin-right-32">
                                        <span className="margin-right-8">
                                          <img src={calendarIcon} />
                                        </span>
                                        <span className="small-dark-secondary">
                                          {this.state.selectedemp
                                            .reviewperiodtypeid == 1
                                            ? shortmonths[
                                                this.state.selectedemp.openid -
                                                  1
                                              ].name
                                            : this.state.selectedemp
                                                .reviewperiodtypeid == 2
                                            ? "Q"
                                            : this.state.selectedemp
                                                .reviewperiodtypeid == 3
                                            ? "H"
                                            : ""}
                                          {this.state.selectedemp
                                            .reviewperiodtypeid != 4
                                            ? this.state.selectedemp
                                                .reviewperiodtypeid != 1
                                              ? this.state.selectedemp.openid
                                              : ""
                                            : ""}{" "}
                                          {this.state.selectedcycle &&
                                            this.state.selectedcycle.year}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="display-flex margin-right-32">
                                        <span className="margin-right-8">
                                          <img src={calendarIcon} />
                                        </span>
                                        <span className="small-dark-secondary">
                                          Manual
                                        </span>
                                      </div>
                                    )}

                                    {/* <IconLabel
                                  label={`${betweenDays({
                                    startdate: new Date(),
                                    enddate: this.state.selectedemp.closedate,
                                  })} days left`}
                                  img={timeIcon}
                                  labelClassNames="small-dark-secondary ellipsis margin-right-32"
                                  iconHeight="16"
                                /> */}
                                    <IconLabel
                                      label={`${
                                        pendingcompletion &&
                                        pendingcompletion.length > 0
                                          ? pendingcompletion.length
                                          : "No"
                                      } participants pending`}
                                      img={employeeIcon}
                                      labelClassNames="small-dark-secondary ellipsis"
                                      iconHeight="16"
                                    />
                                  </div>
                                </div>
                              </Paper>
                            </Grid>
                          </Grid>
                          <Grid container className="margin-top-16" spacing={2}>
                            <EmpList
                              tabId={tabId}
                              empList={empList}
                              selectedempid={this.state.selectedempid}
                              searchValue={searchValue}
                              handleSearch={this.handleSearch}
                              getEmpForms={this.getForm}
                              getoverview={this.getoverview}
                              isSpecialAccess={isSpecialAccess}
                              setAddHoc={this.setAddHoc}
                              selectedemp={this.state.selectedemp}
                              isoverview={this.state.isoverview}
                            />
                            <Grid item md={9} sm={12}>
                              <Paper
                                className="rounded-rectangle-paper padding16"
                                style={{ boxSizing: "border-box" }}
                              >
                                <SelfReviews
                                  {...this.state}
                                  {...this.props}
                                  handleChange={this.handleChange}
                                  HelperSliderFlag={this.HelperSliderFlag}
                                  takeAction={this.takeAction}
                                />
                              </Paper>
                            </Grid>
                          </Grid>
                        </div>
                      )}
                    </div>
                  )}
                  {value === 1 && (
                    <div>
                      {!selectedemp ? (
                        <div>
                          <Grid container>
                            <Results
                              {...this.state}
                              {...this.props}
                              getForms={this.getForms}
                              isSpecialAccess={isSpecialAccess}
                            />
                            {/* <Grid item md={4} sm={12}>
                          <div>
                            <DynamicForm
                              fields={selectinputconverter({
                                value: this.state.employeeid,
                                options:
                                  masterprofileid == 9
                                    ? this.state.allemps
                                    : this.state.empList1,
                                placeholder: "Select employee",
                                label: "Select employee",
                              })}
                              onChange={(id) =>
                                this.handleChange("employeeid", id)
                              }
                            />
                          </div>
                        </Grid>

                         <Grid
                          item
                          md={8}
                          sm={12}
                          className="display-flex"
                          justify="flex-start"
                        >

                          {(value == 0 || (value == 1 && tabId != 2)) && (
                            <span
                              className="inline-block margin-right-8"
                              style={{ width: 240 }}
                            >
                              <DynamicForm
                                fields={selectinputconverter({
                                  value: this.state.cycleid,
                                  options: this.state.performcycles,
                                  placeholder: "Select cycle",
                                  label: "Performance cycle",
                                })}
                                onChange={(id) =>
                                  this.handleChange("cycleid", id)
                                }
                              />
                            </span>
                          )}
                          {(value == 0 || (value == 1 && tabId != 2)) && (
                            <span
                              className="inline-block"
                              style={{ width: 240 }}
                            >
                              <DynamicForm
                                fields={selectinputconverter({
                                  value: this.state.statusid,
                                  options: this.state.statusList,
                                  placeholder: "Select status",
                                  label: "Status",
                                  disabled:
                                    value == 0
                                      ? false
                                      : tabId == 0
                                      ? false
                                      : true,
                                })}
                                onChange={(id) =>
                                  this.handleChange("statusid", id)
                                }
                              />
                            </span>
                          )}
                        </Grid>

                        <Grid container spacing={3}>
                          <Grid item md={3} sm={12}>
                            <Paper
                              className="rounded-rectangle-paper"
                              style={{
                                height: "78vh",
                                boxSizing: "border-box",
                                padding: "16px 0px",
                              }}
                            >
                              <VerticalTabs
                                value={tabId}
                                // onChange={this.handleChange.bind(this, tabId)}
                                indicatorColor="primary"
                                textColor="primary"
                                className="right-border cursurpointer"
                              >
                                <MyTab
                                  label="Employee reviews"
                                  onClick={() => this.handleVerticalChange(0)}
                                  className={
                                    tabId == 0
                                      ? "vertical-tab-item-selected"
                                      : "vertical-tab-item"
                                  }
                                />
                                <MyTab
                                  label="Result and responses"
                                  onClick={() => this.handleVerticalChange(1)}
                                  className={
                                    tabId == 1
                                      ? "vertical-tab-item-selected"
                                      : "vertical-tab-item"
                                  }
                                />
                                <MyTab
                                  label="Preferences"
                                  onClick={() => this.handleVerticalChange(2)}
                                  className={
                                    tabId == 2
                                      ? "vertical-tab-item-selected"
                                      : "vertical-tab-item"
                                  }
                                />
                              </VerticalTabs>
                            </Paper>
                          </Grid>
                          <Grid item md={9} sm={12}>
                            <Paper
                              className="rounded-rectangle-paper padding16"
                              style={{
                                height: "auto",
                                boxSizing: "border-box",
                              }}
                            >
                              {tabId == 0 && (
                                <TabContainer>
                                  <SelfReviews
                                    {...this.state}
                                    {...this.props}
                                    handleChange={this.handleChange}
                                    HelperSliderFlag={this.HelperSliderFlag}
                                    takeAction={this.takeAction}
                                    getForm={this.editForm}
                                    getForms={this.getForms}
                                  />
                                </TabContainer>
                              )}
                              {tabId == 1 && (
                                <TabContainer>
                                  <Results
                                    {...this.state}
                                    {...this.props}
                                    getForms={this.getForms}
                                    isSpecialAccess={isSpecialAccess}
                                  />
                                </TabContainer>
                              )}
                              {tabId == 2 && (
                                <TabContainer>
                                  <Preferences
                                    {...this.state}
                                    {...this.props}
                                    onRef={(ref) => (this.child = ref)}
                                  />
                                </TabContainer>
                              )}
                            </Paper>
                          </Grid>
                        </Grid>
*/}
                          </Grid>
                        </div>
                      ) : (
                        <div>
                          <Grid container>
                            <Grid item md={12} sm={12} style={{ padding: 2 }}>
                              <div className="margin-bottom-16">
                                <span
                                  className="floatleft margin-right-16 cursor-pointer"
                                  onClick={() =>
                                    this.setState(
                                      {
                                        selectedemp: null,
                                        empform: null,
                                        selectedempid: null,
                                        actionemp: null,
                                        offset: 0,
                                        totalcount: 1,
                                        forms: [],
                                        datareceived: false,
                                      },
                                      () => {
                                        this.getForms();
                                      },
                                    )
                                  }
                                >
                                  <img src={backArrow}></img>
                                </span>
                                <span className="floatleft normal-dark-secondary t-bold">
                                  {selectedemp.formtitle}
                                </span>
                                <div className="clear-float"></div>
                              </div>
                            </Grid>
                            <Grid
                              item
                              md={12}
                              sm={12}
                              style={{ padding: 2 }}
                              className="margin-top-16"
                            >
                              <Paper className="rounded-rectangle-paper padding16">
                                <div className="display-flex">
                                  <div className="margin-right-16">
                                    <ProfilePicture
                                      src={getFormattedImageLink(
                                        selectedemp.imagepath,
                                      )}
                                      height="48"
                                    />
                                  </div>
                                  <div>
                                    <span className="large-dark-secondary display-block margin-bottom-8">
                                      {selectedemp.fullname}
                                    </span>
                                    <span className="small-dark-secondary">
                                      {selectedemp.designationname}
                                    </span>
                                  </div>
                                </div>
                              </Paper>
                            </Grid>
                          </Grid>
                          <Grid container className="margin-top-16" spacing={2}>
                            <EmpList
                              tabId={tabId}
                              empList={empList}
                              selectedempid={this.state.selectedempid}
                              searchValue={searchValue}
                              handleSearch={this.handleSearch}
                              getEmpForms={this.getForm}
                              isSpecialAccess={isSpecialAccess}
                              setAddHoc={this.setAddHoc}
                              selectedemp={this.state.selectedemp}
                            />
                            <Grid item md={9} sm={12}>
                              <Paper
                                className="rounded-rectangle-paper padding16"
                                style={{ boxSizing: "border-box" }}
                              >
                                <SelfReviews
                                  {...this.state}
                                  {...this.props}
                                  handleChange={this.handleChange}
                                  getForm={this.editForm}
                                  HelperSliderFlag={this.HelperSliderFlag}
                                  takeAction={this.takeAction}
                                />
                              </Paper>
                            </Grid>
                          </Grid>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
            <Drawer
              anchor="right"
              open={this.state.drawerOpen}
              onClose={() =>
                this.setState({
                  addHoc: false,
                  ParticipantType: [],
                  drawerOpen: false,
                  isOpenReviewForm: false,
                  draweractionid: null,
                  participantselectedid: null,
                })
              }
              classes={{
                paper: classNames(
                  classes.drawerPaper,
                  "planner-drawer padding15",
                ),
              }}
            >
              <DrawerHeader
                header={
                  this.state.addHoc
                    ? "Ad-hoc action"
                    : this.state.isOpenReviewForm
                    ? "Open new review form"
                    : this.state.draweractionid == 1
                    ? "Skip participant"
                    : this.state.draweractionid == 2
                    ? "Exclude participant ratings"
                    : this.state.draweractionid == 7
                    ? "Add skipped participant(s)"
                    : this.state.draweractionid == 8
                    ? "Include participant ratings"
                    : this.state.draweractionid == 9
                    ? "Extend closing date"
                    : this.state.draweractionid == 10
                    ? "Form resubmission"
                    : "Edit peers"
                }
                isbackarrow={false}
                closeDrawer={() =>
                  this.setState({
                    addHoc: false,
                    ParticipantType: [],
                    drawerOpen: false,
                    draweractionid: null,
                    isOpenReviewForm: false,
                  })
                }
              />
              {this.state.addHoc && (
                <div
                  className="thin-scroll"
                  style={{
                    height: "96vh",
                    overflowY: "auto",
                    paddingRight: 15,
                  }}
                  // onScroll={this.handleScroll1}
                >
                  <div className="margin-bottom-16">
                    <Grid container className="margin-top-8">
                      <Grid item xs={12} md={12} sm={12}>
                        <p className="normal-dark margin-bottom-8 display-flex">
                          <img
                            className="margin-right-16"
                            src={pointingHandIcon}
                          ></img>{" "}
                          Select employee to add to this review form
                        </p>
                        <div>
                          <DynamicForm
                            fields={multiselectinputconverter({
                              value: this.state.employeeids,
                              placeholder: "Select employees",
                              label: "Employee",
                              options: adhocemps || [],
                              idonly: true,
                            })}
                            onChange={(ids) => {
                              this.handleChangeAddHoc("employeeids", ids);
                            }}
                          />
                        </div>
                        <div>
                          <DynamicForm
                            fields={selectinputconverter({
                              value: this.state.participanttypeid,
                              placeholder: "Select participant",
                              label: `Employee relation to ${this.state.selectedemp.fullname}`,
                              options: this.state.ParticipantType,
                            })}
                            onChange={(ids) => {
                              this.handleChangeAddHoc("participanttypeid", ids);
                            }}
                          />
                        </div>
                        {this.state.permissions.editable && (
                          <div className="margin-top-16">
                            <Button
                              variant="contained"
                              className="btn btn-primary-md-blue"
                              color="primary"
                              onClick={this.saveAdHoc}
                            >
                              Save
                            </Button>
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )}
              {this.state.isOpenReviewForm && (
                <OpenForm
                  openForms={openForms}
                  masterprofileid={masterprofileid}
                  empList1={this.state.empList1}
                  allemps={this.state.allemps1}
                  clearOpenForm={this.clearOpenForm}
                />
              )}
              {this.state.draweractionid == 1 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Select participants to skip for this review form
                  </p>
                  <div className="rounded-rectangle-div thin-scroll margin-top-24">
                    <div className="margin-top-8">
                      <SearchSq
                        placeholder=""
                        value={this.state.searchparticipantValue}
                        onChange={(e) => this.handleActionSearch(e, 1)}
                      />
                    </div>
                    <List>
                      {this.state.removeparticipantdata.map((x) => (
                        <ListItem style={{ padding: "8px 0px" }}>
                          <ListItemIcon style={{ height: 24 }}>
                            <DynamicForm
                              fields={checkboxinputconverter({
                                // value:
                                //   this.state.cardfilterids.indexOf(1) == -1
                                //     ? false
                                //     : true,
                                value: this.state.removeparticipantdata1.find(
                                  (x1) => x1.employeeid == x.employeeid,
                                ),
                                placeholder: "",
                                label: "",
                                labelclass: "small-dark-secondary width100",
                              })}
                              onChange={(e) => {
                                this.handleChange1(e, x, 1);
                              }}
                              // onClick={(e) => this.takeAction(e, showform, 6)}
                            />
                          </ListItemIcon>
                          <div
                            className="display-flex margin-left-16"
                            style={{
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <ProfilePicture
                              src={
                                x.imagepath
                                  ? getFormattedImageLink(x.imagepath)
                                  : defaultEmp
                              }
                              // src={defaultEmp}
                              height="32"
                              classname="margin-right-16"
                              style={{ borderRadius: 20 }}
                            />
                            <div>
                              <p className="small-dark-secondary">
                                {x.fullname}
                              </p>
                            </div>
                          </div>
                        </ListItem>
                      ))}
                    </List>
                    {this.state.permissions.editable && (
                      <Button
                        color="primary"
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        onClick={(e) =>
                          this.takeAction1(
                            e,
                            this.state.removeparticipantdata1,
                            1,
                          )
                        }
                      >
                        Remove
                      </Button>
                    )}
                  </div>
                </div>
              )}
              {this.state.draweractionid == 7 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Select participants to add
                  </p>
                  <div className="rounded-rectangle-div thin-scroll margin-top-24">
                    {this.state.addparticipantdata &&
                    this.state.addparticipantdata.length > 0 ? (
                      <div>
                        <div className="margin-top-8">
                          <SearchSq
                            placeholder=""
                            value={this.state.searchparticipantValue}
                            onChange={(e) => this.handleActionSearch(e, 7)}
                          />
                        </div>
                        <List>
                          {this.state.addparticipantdata &&
                            this.state.addparticipantdata.map((x) => (
                              <ListItem style={{ padding: "8px 0px" }}>
                                <ListItemIcon style={{ height: 24 }}>
                                  <DynamicForm
                                    fields={checkboxinputconverter({
                                      value:
                                        this.state.addparticipantdata1.find(
                                          (x1) => x1.employeeid == x.employeeid,
                                        ),
                                      placeholder: "",
                                      label: "",
                                      labelclass:
                                        "small-dark-secondary width100",
                                    })}
                                    onChange={(e) => {
                                      this.handleChange1(e, x, 7);
                                    }}
                                    // onClick={(e) => this.takeAction(e, showform, 6)}
                                  />
                                </ListItemIcon>
                                <div
                                  className="display-flex margin-left-16"
                                  style={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <ProfilePicture
                                    src={
                                      x.imagepath
                                        ? getFormattedImageLink(x.imagepath)
                                        : defaultEmp
                                    }
                                    // src={defaultEmp}
                                    height="32"
                                    classname="margin-right-16"
                                    style={{ borderRadius: 20 }}
                                  />
                                  <div>
                                    <p className="small-dark-secondary">
                                      {x.fullname}
                                    </p>
                                  </div>
                                </div>
                              </ListItem>
                            ))}
                        </List>
                        {this.state.permissions.editable && (
                          <Button
                            color="primary"
                            variant="contained"
                            className="btn btn-primary-md-blue"
                            onClick={(e) =>
                              this.takeAction1(
                                e,
                                this.state.addparticipantdata1,
                                7,
                              )
                            }
                          >
                            Add
                          </Button>
                        )}
                      </div>
                    ) : (
                      <p className="small-dark-secondary">
                        No participant to add
                      </p>
                    )}
                  </div>
                </div>
              )}
              {this.state.draweractionid == 2 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Select participants to exclude ratings
                  </p>

                  <div className="rounded-rectangle-div thin-scroll margin-top-24">
                    {this.state.excludeparticipantratingdata &&
                    this.state.excludeparticipantratingdata.length > 0 ? (
                      <div>
                        <div className="margin-top-8">
                          <SearchSq
                            placeholder=""
                            value={this.state.searchexcludeparticipantValue}
                            onChange={(e) => this.handleActionSearch(e, 2)}
                          />
                        </div>

                        <List>
                          {this.state.excludeparticipantratingdata &&
                            this.state.excludeparticipantratingdata.map((x) => (
                              <ListItem style={{ padding: "8px 0px" }}>
                                <ListItemIcon style={{ height: 24 }}>
                                  <DynamicForm
                                    fields={checkboxinputconverter({
                                      // value:
                                      //   this.state.cardfilterids.indexOf(1) == -1
                                      //     ? false
                                      //     : true,
                                      value:
                                        this.state.excludeparticipantratingdata1.find(
                                          (x1) => x1.employeeid == x.employeeid,
                                        ),
                                      placeholder: "",
                                      label: "",
                                      labelclass:
                                        "small-dark-secondary width100",
                                    })}
                                    onChange={(e) => {
                                      this.handleChange1(e, x, 2);
                                    }}
                                    // onClick={(e) => this.takeAction(e, showform, 6)}
                                  />
                                </ListItemIcon>
                                <div
                                  className="display-flex margin-left-16"
                                  style={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <ProfilePicture
                                    src={
                                      x.imagepath
                                        ? getFormattedImageLink(x.imagepath)
                                        : defaultEmp
                                    }
                                    // src={defaultEmp}
                                    height="32"
                                    classname="margin-right-16"
                                    style={{ borderRadius: 20 }}
                                  />
                                  <div>
                                    <p className="small-dark-secondary">
                                      {x.fullname}
                                    </p>
                                  </div>
                                </div>
                              </ListItem>
                            ))}
                        </List>
                        {this.state.permissions.editable && (
                          <Button
                            color="primary"
                            variant="contained"
                            className="btn btn-primary-md-blue"
                            onClick={(e) =>
                              this.takeAction1(
                                e,
                                this.state.excludeparticipantratingdata1,
                                2,
                              )
                            }
                          >
                            Remove
                          </Button>
                        )}
                      </div>
                    ) : (
                      <p className="small-dark-secondary">
                        No participant to exclude
                      </p>
                    )}
                  </div>
                </div>
              )}
              {this.state.draweractionid == 8 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Select participants to include ratings
                  </p>

                  <div className="rounded-rectangle-div thin-scroll margin-top-24">
                    {this.state.includeparticipantratingdata &&
                    this.state.includeparticipantratingdata.length > 0 ? (
                      <div>
                        <div className="margin-top-8">
                          <SearchSq
                            placeholder=""
                            value={this.state.searchincludeparticipantValue}
                            onChange={(e) => this.handleActionSearch(e, 8)}
                          />
                        </div>

                        <List>
                          {this.state.includeparticipantratingdata &&
                            this.state.includeparticipantratingdata.map((x) => (
                              <ListItem style={{ padding: "8px 0px" }}>
                                <ListItemIcon style={{ height: 24 }}>
                                  <DynamicForm
                                    fields={checkboxinputconverter({
                                      // value:
                                      //   this.state.cardfilterids.indexOf(1) == -1
                                      //     ? false
                                      //     : true,
                                      value:
                                        this.state.includeparticipantratingdata1.find(
                                          (x1) => x1.employeeid == x.employeeid,
                                        ),
                                      placeholder: "",
                                      label: "",
                                      labelclass:
                                        "small-dark-secondary width100",
                                    })}
                                    onChange={(e) => {
                                      this.handleChange1(e, x, 8);
                                    }}
                                    // onClick={(e) => this.takeAction(e, showform, 6)}
                                  />
                                </ListItemIcon>
                                <div
                                  className="display-flex margin-left-16"
                                  style={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <ProfilePicture
                                    src={
                                      x.imagepath
                                        ? getFormattedImageLink(x.imagepath)
                                        : defaultEmp
                                    }
                                    // src={defaultEmp}
                                    height="32"
                                    classname="margin-right-16"
                                    style={{ borderRadius: 20 }}
                                  />
                                  <div>
                                    <p className="small-dark-secondary">
                                      {x.fullname}
                                    </p>
                                  </div>
                                </div>
                              </ListItem>
                            ))}
                        </List>
                        {this.state.permissions.editable && (
                          <Button
                            color="primary"
                            variant="contained"
                            className="btn btn-primary-md-blue"
                            onClick={(e) =>
                              this.takeAction1(
                                e,
                                this.state.includeparticipantratingdata1,
                                8,
                              )
                            }
                          >
                            Include
                          </Button>
                        )}
                      </div>
                    ) : (
                      <p className="small-dark-secondary">
                        No participant to include
                      </p>
                    )}
                  </div>
                </div>
              )}
              {this.state.draweractionid == 9 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Employee under review
                  </p>

                  <div className="rounded-rectangle-div thin-scroll margin-top-8 margin-bottom-16">
                    <div
                      className="display-flex"
                      style={{
                        alignItems: "center",
                      }}
                    >
                      <ProfilePicture
                        src={
                          this.state.selectedemp.imagepath
                            ? getFormattedImageLink(
                                this.state.selectedemp.imagepath,
                              )
                            : defaultEmp
                        }
                        height="32"
                        classname="margin-right-16"
                        style={{ borderRadius: 20 }}
                      />
                      <div>
                        <p className="small-dark-secondary">
                          {this.state.selectedemp.fullname}
                        </p>
                      </div>
                    </div>
                  </div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Select participants to grant extension for
                  </p>
                  {selflist && selflist.length > 0 && (
                    <div
                      style={{
                        background: "#edf5fd",
                        padding: 16,
                        position: "relative",
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="width100">
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: this.state.participantselectedid == 1,
                              placeholder: "",
                              label: "Self",
                              // disabled: participant[0].isSelected == false ? true : false,
                              labelclass: "extra-small-dark-secondary",
                            })}
                            onChange={() =>
                              this.handleChange("participantselectedid", 1)
                            }
                          />
                          {this.state.participantselectedid == 1 && (
                            <div>
                              <Grid container>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Employee name
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Actual closing date
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  No of extended days
                                </Grid>
                              </Grid>

                              {selflist &&
                                selflist
                                  .filter((x) => x.participanttypeid == 1)
                                  .map((emp) => (
                                    <Grid
                                      container
                                      style={{
                                        padding: "10px 0px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          className="display-flex"
                                          style={{ alignItems: "center" }}
                                        >
                                          <img
                                            src={
                                              emp.imagepath
                                                ? getFormattedImageLink(
                                                    emp.imagepath,
                                                  )
                                                : defaultEmp
                                            }
                                            height="24"
                                            style={{
                                              borderRadius: 24,
                                              marginRight: 8,
                                            }}
                                          ></img>
                                          <p className="extra-small-dark-secondary ellipsis width80">
                                            {emp.fullname}
                                          </p>
                                        </div>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <p
                                          className="extra-small-dark-secondary"
                                          style={{ marginTop: -8 }}
                                        >
                                          {emp.closedate}
                                        </p>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          style={{
                                            width: "100%",
                                            marginBottom: -16,
                                          }}
                                        >
                                          <DynamicForm
                                            fields={integerinputconverter({
                                              value: emp.extendeddays,

                                              label: "",
                                              min: 1,
                                              // max: 30,
                                            })}
                                            // onChange={(val) =>
                                            //   this.handleChange(
                                            //     "extendeddays",
                                            //     val,
                                            //     3,
                                            //   )
                                            // }
                                            onChange={(e) => {
                                              this.handleChange1(
                                                e,
                                                emp.employeeid,
                                                9,
                                              );
                                            }}
                                          />
                                        </div>
                                      </Grid>
                                    </Grid>
                                  ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {managerlist && managerlist.length > 0 && (
                    <div
                      style={{
                        background: "#edf5fd",
                        padding: 16,
                        position: "relative",
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="width100">
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: this.state.participantselectedid == 2,
                              placeholder: "",
                              label: "Manager(s)",
                              // disabled: participant[0].isSelected == false ? true : false,
                              labelclass: "extra-small-dark-secondary",
                            })}
                            onChange={() =>
                              this.handleChange("participantselectedid", 2)
                            }
                          />
                          {this.state.participantselectedid == 2 && (
                            <div>
                              <Grid container>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Employee name
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Actual closing date
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  No of extended days
                                </Grid>
                              </Grid>

                              {selflist &&
                                selflist
                                  .filter((x) => x.participanttypeid == 2)
                                  .map((emp) => (
                                    <Grid
                                      container
                                      style={{
                                        padding: "10px 0px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          className="display-flex"
                                          style={{ alignItems: "center" }}
                                        >
                                          <img
                                            src={
                                              emp.imagepath
                                                ? getFormattedImageLink(
                                                    emp.imagepath,
                                                  )
                                                : defaultEmp
                                            }
                                            height="24"
                                            style={{
                                              borderRadius: 24,
                                              marginRight: 8,
                                            }}
                                          ></img>
                                          <p className="extra-small-dark-secondary ellipsis width80">
                                            {emp.fullname}
                                          </p>
                                        </div>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <p
                                          className="extra-small-dark-secondary"
                                          style={{ marginTop: -8 }}
                                        >
                                          {emp.closedate}
                                        </p>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          style={{
                                            width: "100%",
                                            marginBottom: -16,
                                          }}
                                        >
                                          <DynamicForm
                                            fields={integerinputconverter({
                                              value: emp.extendeddays,

                                              label: "",
                                              min: 1,
                                              // max: 30,
                                            })}
                                            // onChange={(val) =>
                                            //   this.handleChange(
                                            //     "extendeddays",
                                            //     val,
                                            //     3,
                                            //   )
                                            // }
                                            onChange={(e) => {
                                              this.handleChange1(
                                                e,
                                                emp.employeeid,
                                                9,
                                              );
                                            }}
                                          />
                                        </div>
                                      </Grid>
                                    </Grid>
                                  ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {directreportlist && directreportlist.length > 0 && (
                    <div
                      style={{
                        background: "#edf5fd",
                        padding: 16,
                        position: "relative",
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="width100">
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: this.state.participantselectedid == 3,
                              placeholder: "",
                              label: "Direct reports",
                              // disabled: participant[0].isSelected == false ? true : false,
                              labelclass: "extra-small-dark-secondary",
                            })}
                            onChange={() =>
                              this.handleChange("participantselectedid", 3)
                            }
                          />
                          {this.state.participantselectedid == 3 && (
                            <div>
                              <Grid container>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Employee name
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Actual closing date
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  No of extended days
                                </Grid>
                              </Grid>

                              {selflist &&
                                selflist
                                  .filter((x) => x.participanttypeid == 3)
                                  .map((emp) => (
                                    <Grid
                                      container
                                      style={{
                                        padding: "10px 0px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          className="display-flex"
                                          style={{ alignItems: "center" }}
                                        >
                                          <img
                                            src={
                                              emp.imagepath
                                                ? getFormattedImageLink(
                                                    emp.imagepath,
                                                  )
                                                : defaultEmp
                                            }
                                            height="24"
                                            style={{
                                              borderRadius: 24,
                                              marginRight: 8,
                                            }}
                                          ></img>
                                          <p className="extra-small-dark-secondary ellipsis width80">
                                            {emp.fullname}
                                          </p>
                                        </div>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <p
                                          className="extra-small-dark-secondary"
                                          style={{ marginTop: -8 }}
                                        >
                                          {emp.closedate}
                                        </p>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          style={{
                                            width: "100%",
                                            marginBottom: -16,
                                          }}
                                        >
                                          <DynamicForm
                                            fields={integerinputconverter({
                                              value: emp.extendeddays,

                                              label: "",
                                              min: 1,
                                              // max: 30,
                                            })}
                                            // onChange={(val) =>
                                            //   this.handleChange(
                                            //     "extendeddays",
                                            //     val,
                                            //     3,
                                            //   )
                                            // }
                                            onChange={(e) => {
                                              this.handleChange1(
                                                e,
                                                emp.employeeid,
                                                9,
                                              );
                                            }}
                                          />
                                        </div>
                                      </Grid>
                                    </Grid>
                                  ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {coworkerlist && coworkerlist.length > 0 && (
                    <div
                      style={{
                        background: "#edf5fd",
                        padding: 16,
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="width100">
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: this.state.participantselectedid == 4,
                              placeholder: "",
                              label: "Co-workers",
                              // disabled: participant[0].isSelected == false ? true : false,
                              labelclass: "extra-small-dark-secondary",
                            })}
                            onChange={() =>
                              this.handleChange("participantselectedid", 4)
                            }
                          />
                          {this.state.participantselectedid == 4 && (
                            <div>
                              <Grid container>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Employee name
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  Actual closing date
                                </Grid>
                                <Grid
                                  item
                                  sm={4}
                                  md={4}
                                  style={{ fontSize: 12, textAlign: "left" }}
                                >
                                  No of extended days
                                </Grid>
                              </Grid>

                              {selflist &&
                                selflist
                                  .filter((x) => x.participanttypeid == 4)
                                  .map((emp) => (
                                    <Grid
                                      container
                                      style={{
                                        padding: "10px 0px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          className="display-flex"
                                          style={{ alignItems: "center" }}
                                        >
                                          <img
                                            src={
                                              emp.imagepath
                                                ? getFormattedImageLink(
                                                    emp.imagepath,
                                                  )
                                                : defaultEmp
                                            }
                                            height="24"
                                            style={{
                                              borderRadius: 24,
                                              marginRight: 8,
                                            }}
                                          ></img>
                                          <p className="extra-small-dark-secondary ellipsis width80">
                                            {emp.fullname}
                                          </p>
                                        </div>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <p
                                          className="extra-small-dark-secondary"
                                          style={{ marginTop: -8 }}
                                        >
                                          {emp.closedate}
                                        </p>
                                      </Grid>
                                      <Grid
                                        item
                                        sm={4}
                                        md={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div
                                          style={{
                                            width: "100%",
                                            marginBottom: -16,
                                          }}
                                        >
                                          <DynamicForm
                                            fields={integerinputconverter({
                                              value: emp.extendeddays,

                                              label: "",
                                              min: 1,
                                              // max: 30,
                                            })}
                                            onChange={(e) => {
                                              this.handleChange1(
                                                e,
                                                emp.employeeid,
                                                9,
                                              );
                                            }}
                                          />
                                        </div>
                                      </Grid>
                                    </Grid>
                                  ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.permissions.editable && (
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn btn-primary-md-blue margin-top-16"
                      onClick={(e) =>
                        this.takeAction1(e, this.state.selflist, 9)
                      }
                    >
                      Extend closing date
                    </Button>
                  )}
                </div>
              )}
              {this.state.draweractionid == 10 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Select participant for form resubmission
                  </p>

                  <div className="rounded-rectangle-div thin-scroll margin-top-24">
                    <DynamicForm
                      fields={multiselectinputconverter({
                        value: this.state.selectedparticipants,
                        placeholder: "Select participants",
                        label: "Participant",
                        options: this.state.resubmissiondata || [],
                        idonly: true,
                      })}
                      onChange={(ids) => {
                        this.handleChange1("selectedparticipants", ids, 10);
                      }}
                    />
                  </div>
                  {this.state.permissions.editable && (
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn btn-primary-md-blue margin-top-16"
                      onClick={(e) =>
                        this.takeAction1(e, this.state.selectedparticipants, 10)
                      }
                    >
                      Resubmit
                    </Button>
                  )}
                </div>
              )}
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles(() => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

function TabContainer(props) {
  return <div>{props.children}</div>;
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  LoadingReducer: state.LoaderReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      startLoadProcess,
      stopLoadProcess,
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withStyles(styles, { withTheme: true })(
    withSnackbar(withRouter(SpecialAccess)),
  ),
);
